module.exports = __webpack_public_path__ + "assets/img/d75d953cdce3b17c53f4b114702bd4ec.svg";